// extracted by mini-css-extract-plugin
export default {"user":"UserItem_user__6t4lb","user__copy":"UserItem_user__copy__Us+ug","user__copy_wrapper":"UserItem_user__copy_wrapper__lO3AY"};